// Configuração de variáveis de ambiente
export const ENV_CONFIG = {
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
} as const;

// Debug das variáveis de ambiente
export const debugEnvironment = () => {
};

// Validação das variáveis de ambiente obrigatórias
export const validateEnvironment = () => {
  debugEnvironment();
  
  const requiredVars = {
    VITE_SUPABASE_URL: ENV_CONFIG.SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: ENV_CONFIG.SUPABASE_ANON_KEY,
  };

  const missingVars = Object.entries(requiredVars)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missingVars.length > 0) {
    // Detectar se está rodando no Vercel
    if (import.meta.env.PROD) {
    }
    
    return false;
  }

  return true;
};
